const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.paymentContainer.landing.';

const PAY_NOW = `${DOMAIN}payNowButton`;

export { PAY_NOW };
